import {t} from '@eitje/bridge'
import {useSelectContext} from '../../context'
import {CosmeticCheckbox} from '~/components/checkbox'
import {Text} from '~/components/text'
import {Layout} from '~/components/layout'

export const SelectToggleAll = () => {
	const {showToggleAll, value, items, updateValue, readOnly} = useSelectContext()

	if (!showToggleAll) return null

	const originalItems = items.filter(item => item.type === 'item')._map('data')
	const nonDisabledItems = originalItems.filter(item => !item.disabled)
	if (!nonDisabledItems.length) return null

	const isAllSelected = value.length === originalItems.length
	const isPartiallySelected = value.length > 0 && !isAllSelected

	const handleToggleAll = () => {
		updateValue(originalItems)
	}

	return (
		<Layout
			className="select-toggle-all"
			onClick={readOnly ? undefined : handleToggleAll}
			height={40}
			padding="0 16"
			vertical="center"
			gap={12}
			width="full"
			borderBottom
		>
			<CosmeticCheckbox checked={isPartiallySelected ? 'indeterminate' : isAllSelected} />
			<Text bold truncate noTextSelect>
				{`${value?.length} ${t('common.selected')}`}
			</Text>
		</Layout>
	)
}
